"use client";

import useLocaleLegacy from "@/hooks/use-locale-legacy";
import locale from "@/locales/not-found.json";
import { Link } from "@/src/i18n/navigation";
import { useLocale } from "next-intl";

export default function NotFound() {
  const { t } = useLocaleLegacy(locale);
  const lang = useLocale();

  return (
    <div className="max-w-screen-sm xl:max-w-screen-xl mx-auto text-center mt-56 mb-40">
      <h1 className="text-7xl font-bold">404</h1>
      <p className="text-xl mt-8">{t("title")}</p>

      <p className="text-xl text-[#999]">{t("description")}</p>

      <Link locale={lang} href="/" className="text-brown font-bold">
        {t("back_btn")}
      </Link>
    </div>
  );
}
